// Detects upstream-error blobs that the AI service emits as plain channel-0 text
// chunks (it has no dedicated error channel). Anchored on a literal sentinel so
// legitimate model output mentioning "Error code: 400" never matches.

export const STREAM_ERROR_BUFFER_SIZE = 512;

const SENTINEL = /\*\*\[System Error\]\*\*\s+An error occurred during generation:/i;

const PATTERNS = [
  {
    code: 'TOKEN_LIMIT',
    test: /prompt is too long|context_length_exceeded|too many tokens|maximum context length/i,
    friendlyMessage:
      'This conversation got too long for the model. Start a new chat or shorten your question.',
  },
  {
    code: 'RATE_LIMIT',
    test: /rate.?limit|\b429\b|too many requests/i,
    friendlyMessage: 'Too many requests right now. Please wait a moment and retry.',
  },
  {
    code: 'AUTH',
    test: /\b401\b|unauthori[sz]ed|invalid api key|authentication.error/i,
    friendlyMessage: 'Your session expired. Please reload and sign in again.',
  },
  {
    code: 'UPSTREAM_5XX',
    test: /\b5\d{2}\b|internal server error|service unavailable|bad gateway|gateway timeout/i,
    friendlyMessage: 'The AI service is having trouble. Please retry in a moment.',
  },
  {
    code: 'UPSTREAM_400',
    test: /\bError code:\s*4\d{2}\b|invalid_request_error|\b400\b/i,
    friendlyMessage: "The model couldn't process this request. Try rephrasing your question.",
  },
];

const FALLBACK = {
  code: 'UNKNOWN',
  friendlyMessage: 'Something went wrong while generating the response.',
};

export function classifyStreamError(text) {
  if (!text || typeof text !== 'string') return null;

  const sentinelMatch = text.match(SENTINEL);
  if (!sentinelMatch) return null;

  const matchStart = sentinelMatch.index;
  const errorBody = text.slice(matchStart).trim();

  const matched = PATTERNS.find((p) => p.test.test(errorBody)) || FALLBACK;

  return {
    code: matched.code,
    friendlyMessage: matched.friendlyMessage,
    technicalDetails: errorBody,
    matchStart,
  };
}
